import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=70557cc7&"
import script from "./Lightbox.ts?v=2.2?vue&type=script&lang=ts&"
export * from "./Lightbox.ts?v=2.2?vue&type=script&lang=ts&"
import style0 from "@/components/ap/Lightbox.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports